import React from "react";

const ClockRoundedIcon = React.forwardRef(
  (
    {
      size = 40,
      variant = "solid",           
      bgColor = "#5062F0",
      frameColor = "#5062F0",
      rx = 8,
      strokeWidth = 1,
      baseFill,
      baseStroke,
      wedgeFill,
      wedgeStroke,

      className,
      ...props
    },
    ref
  ) => {
    const isSolid = variant === "solid";

    const _baseFill   = baseFill   ?? "#FFFFFF";
    const _baseStroke = baseStroke ?? (isSolid ? "#010311" : frameColor);
    const _wedgeFill  = wedgeFill  ?? (isSolid ? "#F2B90D" : "#5062F0");
    const _wedgeStroke= wedgeStroke?? (isSolid ? "#010311" : frameColor);

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {isSolid ? (
          <rect width="34" height="34" rx={rx} fill={bgColor} />
        ) : (
          <rect
            x="0.5"
            y="0.5"
            width="33"
            height="33"
            rx={rx - 0.5}
            fill="none"
            stroke={frameColor}
            strokeWidth={1}
            vectorEffect="non-scaling-stroke"
          />
        )}

        <path
          d="M25 17C25 18.5823 24.5308 20.129 23.6518 21.4446C22.7727 22.7602 21.5233 23.7855 20.0615 24.391C18.5997 24.9965 16.9911 25.155 15.4393 24.8463C13.8874 24.5376 12.462 23.7757 11.3431 22.6569C10.2243 21.538 9.4624 20.1126 9.15372 18.5607C8.84504 17.0089 9.00346 15.4003 9.60896 13.9385C10.2145 12.4767 11.2398 11.2273 12.5554 10.3482C13.871 9.46919 15.4177 9 17 9V17H25Z"
          fill={_baseFill}
          stroke={_baseStroke}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />

        <path
          d="M25 17C25 15.9494 24.7931 14.9091 24.391 13.9385C23.989 12.9679 23.3997 12.086 22.6569 11.3431C21.914 10.6003 21.0321 10.011 20.0615 9.60896C19.0909 9.20693 18.0506 9 17 9L17 17H25Z"
          fill={_wedgeFill}
          stroke={_wedgeStroke}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    );
  }
);

export default React.memo(ClockRoundedIcon);
